/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { HitAlphabetSoupAnswerRequest } from '../models/hit-alphabet-soup-answer.request';
import { AlphabetSoupAnswer } from '../models/alphabet-soup-answer.entity';

export type AlphabetSoupAnswerUpdatePathVariables = {
	gameId: string;
	roundId: string;
	soupId: string;
	answerId: string;
};

@Injectable()
export class AlphabetSoupAnswerService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public update(
		path: AlphabetSoupAnswerUpdatePathVariables,
		body: HitAlphabetSoupAnswerRequest,
	): Observable<AlphabetSoupAnswer> {
		return this.http.patch<AlphabetSoupAnswer>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/phases/soups/${path.roundId}/soups/${path.soupId}/answers/${path.answerId}`,
			body,
		);
	}
}
